import React from 'react';

export default function LogoIcon({ className, size = 512, style }) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 512 512" 
      width={size} 
      height={size} 
      className={className}
      style={style}
    >
      <defs>
        {/* Градиент рамки: бирюза (верх-лево) → розовый (низ-право) */}
        <linearGradient id="gFrame" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#4CEABE"/>
          <stop offset="15%" stopColor="#3AD4D8"/>
          <stop offset="35%" stopColor="#4C90F0"/>
          <stop offset="55%" stopColor="#6870F0"/>
          <stop offset="75%" stopColor="#A050E0"/>
          <stop offset="100%" stopColor="#F04898"/>
        </linearGradient>

        {/* Градиент столбцов: голубой → синий → фиолетовый */}
        <linearGradient id="gBar" x1="0.3" y1="0" x2="0.7" y2="1">
          <stop offset="0%" stopColor="#56B0F8"/>
          <stop offset="35%" stopColor="#5E90F4"/>
          <stop offset="70%" stopColor="#7070F0"/>
          <stop offset="100%" stopColor="#8860E8"/>
        </linearGradient>

        {/* Градиент калькулятора: фиолетовый → розовый/маджента */}
        <linearGradient id="gCalc" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#8858F0"/>
          <stop offset="40%" stopColor="#B848D0"/>
          <stop offset="100%" stopColor="#F04898"/>
        </linearGradient>

        {/* Тень калькулятора */}
        <filter id="fShadow" x="-8%" y="-4%" width="120%" height="120%">
          <feDropShadow dx="0" dy="3" stdDeviation="6" floodColor="rgba(0,0,0,0.15)"/>
        </filter>
      </defs>

      {/* РАМКА: полный скруглённый прямоугольник (Внешний контур минус внутренний вырез) */}
      <path d="
        M 114,18 
        L 398,18 
        C 452,18, 494,60, 494,114 
        L 494,398 
        C 494,452, 452,494, 398,494 
        L 114,494 
        C 60,494, 18,452, 18,398 
        L 18,114 
        C 18,60, 60,18, 114,18 
        Z

        M 114,64 
        C 86,64, 64,86, 64,114 
        L 64,398 
        C 64,426, 86,448, 114,448 
        L 398,448 
        C 426,448, 448,426, 448,398 
        L 448,114 
        C 448,86, 426,64, 398,64 
        L 114,64 
        Z
      " fill="url(#gFrame)" fillRule="evenodd"/>

      {/* Белая/тёмная заливка внутри рамки, управляемая через глобальный CSS (data-theme) */}
      <rect x="64" y="64" width="384" height="384" rx="50" className="logo-inner-fill"/>

      {/* СТОЛБЦЫ ГИСТОГРАММЫ */}
      <rect x="86" y="290" width="72" height="158" rx="16" fill="url(#gBar)"/>
      <rect x="178" y="190" width="72" height="258" rx="16" fill="url(#gBar)"/>
      <rect x="270" y="60" width="72" height="388" rx="16" fill="url(#gBar)"/>

      {/* КАЛЬКУЛЯТОР */}
      <rect x="300" y="300" width="200" height="200" rx="46" fill="url(#gCalc)" filter="url(#fShadow)"/>

      {/* Символы калькулятора */}
      <g fill="none" stroke="white" strokeLinecap="round">
        {/* + плюс */}
        <line x1="370" y1="358" x2="370" y2="398" strokeWidth="9"/>
        <line x1="350" y1="378" x2="390" y2="378" strokeWidth="9"/>

        {/* − минус */}
        <line x1="440" y1="378" x2="480" y2="378" strokeWidth="9"/>

        {/* × умножить */}
        <line x1="354" y1="434" x2="386" y2="466" strokeWidth="9"/>
        <line x1="386" y1="434" x2="354" y2="466" strokeWidth="9"/>

        {/* ═ равно */}
        <line x1="440" y1="440" x2="480" y2="440" strokeWidth="8"/>
        <line x1="440" y1="460" x2="480" y2="460" strokeWidth="8"/>
      </g>
    </svg>
  );
}
